import { LOCAL_STORE, LOGIN } from '../constants/localStorageNames';
import { StorageNamesEnum } from '../enums/StorageNamesEnum';
import { ILocalStore } from '../interfaces/ILocalStore';
import { getLawInterfaceFromStorage } from './getLawInterfaceFromStorage';

export const mapStorageNamesByVersion: Record<StorageNamesEnum, string> = {
  [StorageNamesEnum.KNM_LIST_TABLE_COLUMNS]: 'v1',
  [StorageNamesEnum.KNM_LIST_ORDER]: 'v1',
  [StorageNamesEnum.KNM_FILTER]: 'v1',
  [StorageNamesEnum.PLAN_FILTER]: 'v1',
  [StorageNamesEnum.PLAN_FILTER_ON]: 'v1',
  [StorageNamesEnum.KNM_FILTER_ON]: 'v1',
  [StorageNamesEnum.PM_FILTER]: 'v1',
  [StorageNamesEnum.PM_FILTER_ON]: 'v1',
  [StorageNamesEnum.DECISION_FILTER]: 'v1',
  [StorageNamesEnum.DECISION_FILTER_ON]: 'v1',
  [StorageNamesEnum.SIMILARITIES_LIST_ORDER]: 'v1',
  [StorageNamesEnum.ERKNM_ANALYTICS_COLUMNS]: 'v1',
  [StorageNamesEnum.CERT_SERIAL_NUMBER]: 'v1',
  [StorageNamesEnum.USER_FIRST_LOGIN]: 'v1',
  [StorageNamesEnum.SHOWED_GENERAL_PROSECUTOR_ADDED]: 'v1',
  [StorageNamesEnum.AGREEMENT_LIST_TABLE_COLUMNS]: 'v1',
  [StorageNamesEnum.AGREEMENT_LIST_ORDER]: 'v1',
  [StorageNamesEnum.AGREEMENT_LIST_FILTER]: 'v1',
  [StorageNamesEnum.AGREEMENT_LIST_FILTER_ON]: 'v1',
};

export function getStorageItem<T>(storageName?: StorageNamesEnum): T | undefined {
  try {
    const storeString = localStorage.getItem(LOCAL_STORE);
    const lawInterface = getLawInterfaceFromStorage();
    const userName = sessionStorage.getItem(LOGIN);

    if (storageName && userName && storeString && lawInterface) {
      const store = JSON.parse(storeString) as ILocalStore<T>;
      const currentData = store[userName][lawInterface][storageName];

      if (currentData.version === mapStorageNamesByVersion[storageName]) {
        return currentData.data;
      }
    }
  } catch (err) {
    //
  }

  return undefined;
}

export function setStorageItem<T>(storageName: StorageNamesEnum, value: T): void {
  try {
    const storeString = localStorage.getItem(LOCAL_STORE);
    const lawInterface = getLawInterfaceFromStorage();
    const userName = sessionStorage.getItem(LOGIN);

    if (lawInterface && userName) {
      const store = storeString ? (JSON.parse(storeString) as ILocalStore<T>) : undefined;
      const includeStoreByLawInterface = store ? store[userName] : undefined;
      const includeStoreByStorageName = includeStoreByLawInterface
        ? includeStoreByLawInterface[lawInterface]
        : undefined;
      const resultStore = {
        ...store,
        [userName]: {
          ...includeStoreByLawInterface,
          [lawInterface]: {
            ...includeStoreByStorageName,
            [storageName]: {
              version: mapStorageNamesByVersion[storageName],
              data: value,
            },
          },
        },
      };

      localStorage.setItem(LOCAL_STORE, JSON.stringify({ ...store, ...resultStore }));
    }
  } catch (err) {
    throw new Error('Set storage error');
  }
}
